"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCaller = void 0;
var react_1 = __importDefault(require("react"));
function createCaller(initCaller) {
    return {
        initCaller: initCaller,
        call: {},
    };
}
exports.createCaller = createCaller;
var OutsideCallConsumer = function (_a) {
    var config = _a.config;
    for (var key in config.initCaller) {
        config.call[key] = config.initCaller[key]();
    }
    return null;
};
var OutsideCallConsumerWrapper = function (_a) {
    var children = _a.children, config = _a.config;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        react_1.default.createElement(OutsideCallConsumer, { config: config })));
};
exports.default = OutsideCallConsumerWrapper;
